import { useEffect } from 'react';
import { Player } from '@brightcove/web-sdk/ui';

import {
  trackPlayerBufferComplete,
  trackPlayerBufferStart,
  trackPlayerClosed,
  trackPlayerPause,
  trackPlayerPlay,
  trackPlayerPresented,
  trackPlayerSeekComplete,
  trackPlayerSeekStart,
  trackPlayerComplete,
  trackPlayerSessionStart,
  trackPlayerError,
} from '~/components/player/tracking.ts';
import type { PlayerTrackData } from '~/components/player/tracking.ts';

const usePlayerAnalytics = (
  player: Player | null,
  trackData: PlayerTrackData
) => {
  useEffect(() => {
    if (player) {
      player.addEventListener(Player.Event.PlayerLoadedMetadata, () =>
        trackPlayerSessionStart(trackData, player.getCurrentTime())
      );
      player.addEventListener(Player.Event.PlayerEnded, () =>
        trackPlayerComplete(trackData, player.getCurrentTime())
      );
      player.addEventListener(Player.Event.PlayerCanPlayThrough, () =>
        trackPlayerBufferComplete(trackData, player.getCurrentTime())
      );
      player.addEventListener(Player.Event.PlayerWaiting, () =>
        trackPlayerBufferStart(trackData, player.getCurrentTime())
      );
      player.addEventListener(Player.Event.PlayerSeeking, () =>
        trackPlayerSeekStart(trackData, player.getCurrentTime())
      );
      player.addEventListener(Player.Event.PlayerSeeked, () =>
        trackPlayerSeekComplete(trackData, player.getCurrentTime())
      );
      player.addEventListener(Player.Event.PlayerPlay, () =>
        trackPlayerPlay(trackData, player.getCurrentTime())
      );
      player.addEventListener(Player.Event.PlayerPause, () =>
        trackPlayerPause(trackData, player.getCurrentTime())
      );
      player.addEventListener(Player.Event.PlayerError, () =>
        trackPlayerError(trackData, player.getCurrentTime())
      );
      player.addEventListener(Player.Event.PlayerDisposed, () =>
        trackPlayerClosed(trackData, player.getCurrentTime())
      );
      player.addEventListener(Player.Event.PlayerLoadedData, () =>
        trackPlayerPresented(trackData, player.getCurrentTime())
      );
    }

    return () => {
      player?.removeAllEventListeners();
    };
  }, [player, trackData]);
};

export default usePlayerAnalytics;
